import { createMuiTheme } from "@material-ui/core/styles";

export default createMuiTheme({
  palette: {
    background: {
      default: "#f4f6f1",
      paper: "#f4f6f1",
    },
    text: {
      primary: "#464843",
      secondary: "#999",
    },
  },
  typography: {
    fontFamily: [
      "Futura",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h6: {
      fontSize: "1.1rem",
      lineHeight: 1.2,
    },
    body1: {
      fontWeight: 100,
    },
  },
});
